"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.QueryBarGenerator = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _facetFilter = require("@bento-core/facet-filter");
var _clsx = _interopRequireDefault(require("clsx"));
var _FilterMap = require("../components/FilterMap");
var _styles = _interopRequireDefault(require("./styles"));
var _config = _interopRequireDefault(require("./config"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
/**
 * Generate a pre-configured Explore Query Bar component
 *
 * @param {object} uiConfig the component configuration object
 * @returns {object} { QueryBar }
 */
var QueryBarGenerator = function QueryBarGenerator() {
  var uiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config.default;
  var config = uiConfig.config,
    functions = uiConfig.functions,
    _uiConfig$customStyle = uiConfig.customStyles,
    customStyles = _uiConfig$customStyle === void 0 ? {} : _uiConfig$customStyle;
  var CHECKBOX = _facetFilter.InputTypes.CHECKBOX;
  var styles = function styles() {
    return _objectSpread(_objectSpread({}, (0, _styles.default)()), customStyles);
  };
  var maxItems = config && typeof config.maxItems === 'number' ? config.maxItems : _config.default.config.maxItems;
  var clearAll = functions && typeof functions.clearAll === 'function' ? functions.clearAll : _config.default.functions.clearAll;
  var clearUpload = functions && typeof functions.clearUpload === 'function' ? functions.clearUpload : _config.default.functions.clearUpload;
  var clearAutocomplete = functions && typeof functions.clearAutocomplete === 'function' ? functions.clearAutocomplete : _config.default.functions.clearAutocomplete;
  var deleteAutocompleteItem = functions && typeof functions.deleteAutocompleteItem === 'function' ? functions.deleteAutocompleteItem : _config.default.functions.deleteAutocompleteItem;
  var resetFacetSection = functions && typeof functions.resetFacetSection === 'function' ? functions.resetFacetSection : _config.default.functions.resetFacetSection;
  var resetFacetCheckbox = functions && typeof functions.resetFacetCheckbox === 'function' ? functions.resetFacetCheckbox : _config.default.functions.resetFacetCheckbox;
  var resetFacetSlider = functions && typeof functions.resetFacetSlider === 'function' ? functions.resetFacetSlider : _config.default.functions.resetFacetSlider;
  var clsName = function clsName() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'filter-section';
    return text.replace(/\s+/g, '-').toLowerCase();
  };
  return {
    QueryBar: (0, _core.withStyles)(styles, {
      withTheme: true
    })(function (props) {
      var statusReducer = props.statusReducer,
        localFind = props.localFind,
        classes = props.classes;
      var autocomplete = localFind.autocomplete,
        upload = localFind.upload;
      var _ref = (0, _react.useState)(true),
        _ref2 = _slicedToArray(_ref, 2),
        expand = _ref2[0],
        setExpand = _ref2[1];
      var noOfItems = expand ? autocomplete.length : maxItems;

      // Remove any sections without checkboxes selected
      var mappedInputs = statusReducer.filter(function (facet) {
        return facet.section && facet.type;
      }).map(function (facet) {
        if (facet.type !== CHECKBOX) {
          return facet;
        }
        var items = facet.items;
        var itemKeys = Object.keys(items);
        itemKeys.sort(function (a, b) {
          return a.localeCompare(b);
        });

        /**
        * to display all the active filters in the query bar
        * ICDC-3287
        */
        return _objectSpread(_objectSpread({}, facet), {}, {
          items: itemKeys
        });
      }).filter(function (facet) {
        return facet.items.length > 0;
      });
      if ((mappedInputs.length || autocomplete.length || upload.length) <= 0) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes.queryWrapper
      }, /*#__PURE__*/_react.default.createElement(_core.Button, {
        className: classes.clearQueryButton,
        color: "primary",
        variant: "outlined",
        onClick: clearAll
      }, "Clear Query"), /*#__PURE__*/_react.default.createElement("span", {
        className: classes.divider
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: classes.queryContainer
      }, autocomplete.length || upload.length ? /*#__PURE__*/_react.default.createElement("span", null, upload.length && !autocomplete.length ? /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _clsx.default)(classes.filterCheckboxes, classes.localFindBackground),
        onClick: clearUpload
      }, "INPUT CASE SET") : null, autocomplete.length ? /*#__PURE__*/_react.default.createElement("span", null, ' ', /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _clsx.default)(classes.filterName, classes.localFindBackground),
        onClick: clearAutocomplete
      }, "Case IDs"), ' ', ' ', /*#__PURE__*/_react.default.createElement("span", {
        className: classes.operators
      }, autocomplete.length === 1 && !upload.length ? 'IS ' : 'IN ')) : null, /*#__PURE__*/_react.default.createElement("span", null, (upload.length > 0 ? 1 : 0) + autocomplete.length > 1 ? /*#__PURE__*/_react.default.createElement("span", {
        className: classes.bracketsOpen
      }, "(") : null, upload.length && autocomplete.length ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ' ', /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _clsx.default)(classes.filterCheckboxes, classes.localFind),
        onClick: clearUpload
      }, "INPUT CASE SET"), ' ') : null, autocomplete.slice(0, noOfItems).map(function (d, idx) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
          className: (0, _clsx.default)(classes.filterCheckboxes, classes.facetSectionCases),
          key: idx,
          onClick: function onClick() {
            return deleteAutocompleteItem(d.title);
          }
        }, d.title), idx === noOfItems - 1 ? null : ' ');
      }), autocomplete.length > maxItems && !expand && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
        className: classes.expandBtn,
        onClick: function onClick() {
          return setExpand(!expand);
        }
      }, "...")), expand && autocomplete.length > maxItems && /*#__PURE__*/_react.default.createElement("span", {
        className: classes.collapseBtn,
        onClick: function onClick() {
          return setExpand(!expand);
        }
      }, ' LESS'), (upload.length > 0 ? 1 : 0) + autocomplete.length > 1 ? /*#__PURE__*/_react.default.createElement("span", {
        className: classes.bracketsClose
      }, ")") : null)) : null, (autocomplete.length || upload.length) && mappedInputs.length ? /*#__PURE__*/_react.default.createElement("span", {
        className: classes.operators
      }, " AND ") : null, mappedInputs.map(function (filter, index) {
        return /*#__PURE__*/_react.default.createElement("span", {
          className: clsName(filter.section)
        }, /*#__PURE__*/_react.default.createElement(_FilterMap.Filter, {
          index: index,
          type: filter.type,
          data: filter,
          maxItems: maxItems,
          classes: classes,
          onSectionClick: filter.type === CHECKBOX ? resetFacetSection : resetFacetSlider,
          onItemClick: filter.type === CHECKBOX ? resetFacetCheckbox : resetFacetSlider
        }));
      })));
    })
  };
};
exports.QueryBarGenerator = QueryBarGenerator;
var _default = QueryBarGenerator;
exports.default = _default;